export default "__VITE_ASSET__Z6IwMaLN__"